import { Box, TextField, Typography } from '@mui/material'
import axios from "axios";
import _ from "lodash";

import { ErrorMessage, Field, useFormikContext, FastField } from 'formik'
import React, { useEffect, useState } from 'react'

import TextError from '../TextError'


function FormikInput(props) {
    const Axios = axios.create({
        withCredentials: true, // This allows Axios to include cookies in requests
      });

    const { placeholder,label, name, validation,type, customeValidation, previousIndex, readOnly, hidden, prevArrayIndex, manualValidation, arrayindex, schemeId, url, errors, productName, ...rest } = props

    const [localManualFunction, setLocalManualFunction] = useState('');

    const { submitForm, setFieldError,values } = useFormikContext();

    // console.log('URL',url,name,arrayindex)

    //console.log('name',name)
    //console.log('hidd',hidden)
    // console.log('shs',schemeId)
    // console.log('manualValidation', manualValidation !== undefined ? window[`${manualValidation}`] : null)

    useEffect(() => {
        /*  if (manualValidation !== undefined) {
             setLocalManualFunction(manualValidation)
         } else {
             setLocalManualFunction('');
         } */
        //console.log('fofof',values.nomineeDetail[0].nomineeAge)
         
         //console.log('iiin',name,values)
    }, [])

    //console.log('loc',localManualFunction)

    return (
        <div >

            <div>
                {/*  <Typography  >{label}</Typography> */}
                <Typography  >{hidden ? null : label}</Typography>
                {/*               <Field id={name} 
            name={name} {...rest} 
            placeholder={label} style={{width:'60%'}} 
            
            label={label}/>  */}

                <Field name={name}
                //validate={val=> localManualFunction !== ''  ? window[`${localManualFunction}`](val) :null}
                //validate={val => name === 'aadharNumber' ? validateAdharCard(label, val): null }
                >
                    {
                        ({ form, field }) => {
                            const { setFieldValue, setErrors, values } = form
                            //const { values } = form

                            const handleChange = (val) => {
                                let incomingVal = val.target.value;
                                //console.log('ssasa',name,arrayindex,prevArrayIndex,previousIndex)

                                if (name === 'dependentDetail.proposerResidencePostalCode' && url !== undefined) {
                                    let proposerAreaName;
                                    //console.log(`${url}${incomingVal}`)
                                    
                                   _.size(incomingVal) === 6 && Axios.get(`${url}${incomingVal}`).then((res) => {
                                        console.log('url res', res)

                                        if (res.data.proposerAreaId !== undefined) {
                                            proposerAreaName = res.data.proposerAreaName
                                            //console.log('url res proposerAreaName', res.data.proposerAreaName)

                                            setFieldValue('dependentDetail.proposerResidenceAreaId', res.data.proposerAreaId)
                                        } else {
                                            setFieldValue('dependentDetail.proposerResidenceAreaId', '')
                                            //form.setFieldError('proposerResidenceAreaId','Please give proper postal')
                                        }
                                    }).catch(e => console.log(e.message))
                                    //console.log('proposerAreaName', proposerAreaName)
                                }

                                if(name === 'pan'){
                                 
                                        if(incomingVal=== ''){
                                            // setFieldValue("stateName",res.data.stateName)
                                            setFieldValue("isForm60required",'')
                                            // console.log("show checkbox again !")
                                            document.getElementById('isForm60required').closest('div').closest('.mb-3').removeAttribute('hidden')
                                           
                                        }else{
                                            setFieldValue("isForm60required",false)
                                            // console.log("hide isform60 checkbox !")
                                            document.getElementById('isForm60required').closest('div').closest('.mb-3').setAttribute('hidden', true)

                                        }
                                  
                                } 
 
                                if(name === 'dependentDetail.Customer_Perm_PinCode' && url !== undefined){
                                   _.size (incomingVal) === 6 && Axios.get(`${url}${incomingVal}`).then((res) => {
                                        console.log('url res', res)
                                        
                                        if(res.data !== undefined){
                                            setFieldValue("dependentDetail.Customer_Perm_PinCodeLocality",res.data.pincodeLocality)
                                            setFieldValue("dependentDetail.Customer_Perm_CityDirstCode",res.data.cityDistCd)
                                            setFieldValue("dependentDetail.Customer_Perm_StateCode",res.data.stateCd)
                                            setFieldValue("dependentDetail.Customer_Perm_CityDistrict",res?.data?.TXT_CITYDISTRICT ?? "")
                                            setFieldValue("dependentDetail.Customer_PermState",res?.data?.TXT_STATE ?? "")
                                        }else{
                                            console.log("HDFCERGOCQ Pincode Error Msg:",res.data.details[0])
                                        }
                                    }).catch(e => console.log(e.message))
                                }
                                if(name === 'dependentDetail.Customer_Mailing_PinCode' && url !== undefined){
                                   _.size (incomingVal) === 6 && Axios.get(`${url}${incomingVal}`).then((res) => {
                                        console.log('url res', res)
                                        
                                        if(res.data !== undefined){
                                            setFieldValue("dependentDetail.Customer_Mailing_PinCodeLocality",res.data.pincodeLocality)
                                            setFieldValue("dependentDetail.Customer_Mailing_CityDistrictCode",res.data.cityDistCd)
                                            setFieldValue("dependentDetail.Customer_Mailing_StateCode",res.data.stateCd)
                                            setFieldValue("dependentDetail.Customer_Mailing_CityDistrict",res?.data?.TXT_CITYDISTRICT ?? "")
                                            setFieldValue("dependentDetail.Customer_Mailing_State",res?.data?.TXT_STATE ?? "")
                                        }else{
                                            console.log("HDFCERGOCQ Pincode Error Msg:",res.data.details[0])
                                        }
                                    }).catch(e => console.log(e.message))
                                }
                                if(name === 'postalCode' && url !== undefined){
                                   _.size (incomingVal) === 6 && Axios.get(`${url}${incomingVal}`).then((res) => {
                                        console.log('url res', res)
                                        
                                        if(res.data !== undefined){
                                            setFieldValue("stateName",res.data.stateName)
                                            setFieldValue("stateCode",res.data.stateCode)
                                            setFieldValue("districtName",res.data.districtName)
                                        }else{
                                            console.log("Star Pincode Error Msg:",res.data.details[0])
                                        }
                                    }).catch(e => console.log(e.message))
                                } 

                                if (name === `primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].pinCode`
                                    || name === `primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].pinCode2`) {

                                    //console.log(`${url}${incomingVal}`, arrayindex)
                                   // console.log('kk',values[`primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].pinCode`])
                                    /* if(values[]){

                                    } */
                                   _.size (incomingVal) === 6 && Axios.get(`${url}${incomingVal}`).then((res) => {
                                        console.log('url res', res)

                                        if (res.data.message !== undefined) {
                                            if (name === `primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].pinCode`) {
                                                setFieldValue(`primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].cityCd`, '')
                                                setFieldValue(`primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].areaCd`, '')
                                                setFieldValue(`primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].stateCd`, '')
                                            } else if (name === `primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].pinCode2`) {
                                                setFieldValue(`primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].cityCd2`, '')
                                                setFieldValue(`primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].areaCd2`, '')
                                                setFieldValue(`primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].stateCd2`, '')
                                            }
                                        } else {
                                            if (name === `primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].pinCode`) {
                                                if (res.data.citycd !== undefined && res.data.statecd !== undefined) {
                                                    setFieldValue(`primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].cityCd`, res.data.citycd)
                                                    setFieldValue(`primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].areaCd`, res.data.citycd)
                                                    setFieldValue(`primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].stateCd`, res.data.statecd)
                                                }

                                            } else if (name === `primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].pinCode2`) {
                                                if (res.data.citycd !== undefined && res.data.statecd !== undefined) {
                                                    setFieldValue(`primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].cityCd2`, res.data.citycd)
                                                    setFieldValue(`primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].areaCd2`, res.data.citycd)
                                                    setFieldValue(`primaryDetail[${previousIndex}].partyAddressDOList[${arrayindex}].stateCd2`, res.data.statecd)
                                                }

                                            }
                                        }
                                        //proposerAreaName=res.data.proposerAreaName





                                    }).catch(e => {


                                        // console.log('eror url', e)

                                    }
                                    )

                                }

                                if (name === `dependentDetail.partyAddressDOList[${arrayindex}].pinCode`
                                    || name === `dependentDetail.partyAddressDOList[${arrayindex}].pinCode2`) {

                                    //console.log(`${url}${incomingVal}`, arrayindex)

                                   _.size (incomingVal) === 6 && Axios.get(`${url}${incomingVal}`).then((res) => {
                                        console.log('url res', res)

                                        if (res.data.message !== undefined) {
                                            if (name === `dependentDetail.partyAddressDOList[${arrayindex}].pinCode`) {
                                                setFieldValue(`dependentDetail.partyAddressDOList[${arrayindex}].cityCd`, '')
                                                setFieldValue(`dependentDetail.partyAddressDOList[${arrayindex}].areaCd`, '')
                                                setFieldValue(`dependentDetail.partyAddressDOList[${arrayindex}].stateCd`, '')
                                            } else if (name === `dependentDetail.partyAddressDOList[${arrayindex}].pinCode2`) {
                                                setFieldValue(`dependentDetail.partyAddressDOList[${arrayindex}].cityCd2`, '')
                                                setFieldValue(`dependentDetail.partyAddressDOList[${arrayindex}].areaCd2`, '')
                                                setFieldValue(`dependentDetail.partyAddressDOList[${arrayindex}].stateCd2`, '')
                                            }
                                        } else {
                                            if (name === `dependentDetail.partyAddressDOList[${arrayindex}].pinCode`) {
                                                if (res.data.citycd !== undefined && res.data.statecd !== undefined) {
                                                    setFieldValue(`dependentDetail.partyAddressDOList[${arrayindex}].cityCd`, res.data.citycd)
                                                    setFieldValue(`dependentDetail.partyAddressDOList[${arrayindex}].areaCd`, res.data.citycd)
                                                    setFieldValue(`dependentDetail.partyAddressDOList[${arrayindex}].stateCd`, res.data.statecd)
                                                }

                                            } else if (name === `dependentDetail.partyAddressDOList[${arrayindex}].pinCode2`) {
                                                if (res.data.citycd !== undefined && res.data.statecd !== undefined) {
                                                    setFieldValue(`dependentDetail.partyAddressDOList[${arrayindex}].cityCd2`, res.data.citycd)
                                                    setFieldValue(`dependentDetail.partyAddressDOList[${arrayindex}].areaCd2`, res.data.citycd)
                                                    setFieldValue(`dependentDetail.partyAddressDOList[${arrayindex}].stateCd2`, res.data.statecd)
                                                }

                                            }
                                        }
                                        //proposerAreaName=res.data.proposerAreaName
                                    }).catch(e => {
                                        console.log('eror url', e)
                                    })
                                }
                                if(name === 'dependentDetail.zipcode' && url !== undefined){
                                   
                                   _.size (incomingVal) === 6 && Axios.get(`${url}${incomingVal}`).then((res) => {
                                        console.log('url res', res)
                                        
                                        if(res.data !== undefined){
                                            setFieldValue("dependentDetail.city",res.data.cityDistCd)
                                            setFieldValue("dependentDetail.districtCode",res.data.cityDistCd)
                                            setFieldValue("dependentDetail.cityName",res.data.TXT_CITYDISTRICT)
                                            setFieldValue("dependentDetail.district",res.data.TXT_CITYDISTRICT)
                                            setFieldValue("dependentDetail.state",res.data.stateCd)
                                        }else{
                                            console.log("HDFCERGOCQ Pincode Error Msg:",res.data.details[0])
                                        }
                                    }).catch(e => console.log(e.message))
                                }

                                setFieldValue(name, val.target.value)

                                if (name === 'nomineeDetail[0].nomineeAge') {
                                    //console.log('input console', val.target.value)
                                    if (val.target.value < 18 && val.target.value !== '') {
                                        document.getElementById('nomineeDetail[0].appointeeName').closest('.mb-3').removeAttribute('hidden')
                                        document.getElementById('nomineeDetail[0].appointeeAge').closest('.mb-3').removeAttribute('hidden')
                                        document.getElementById('nomineeDetail[0].appointeeRelationship').closest('div').closest('.mb-3').removeAttribute('hidden')

                                    } else {
                                        document.getElementById('nomineeDetail[0].appointeeName').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeDetail[0].appointeeName', '')
                                        document.getElementById('nomineeDetail[0].appointeeAge').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeDetail[0].appointeeAge', '')
                                        document.getElementById('nomineeDetail[0].appointeeRelationship').closest('div').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeDetail[0].appointeeRelationship', '')

                                    }

                                    //console.log('gsgsg', document.getElementById('appointeeRelationship').closest('div').closest('.mb-3'))
                                }
                                if (name === 'nomineeDetail[0].nomineeAgeTwo') {
                                    //console.log('input console', val.target.value)
                                    if (val.target.value < 18 && val.target.value !== '') {
                                        document.getElementById('nomineeDetail[0].appointeeNameTwo').closest('.mb-3').removeAttribute('hidden')
                                        document.getElementById('nomineeDetail[0].appointeeAgeTwo').closest('.mb-3').removeAttribute('hidden')
                                        document.getElementById('nomineeDetail[0].appointeeRelationshipTwo').closest('div').closest('.mb-3').removeAttribute('hidden')
                                    } else {
                                        document.getElementById('nomineeDetail[0].appointeeNameTwo').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeDetail[0].appointeeNameTwo', '')
                                        document.getElementById('nomineeDetail[0].appointeeAgeTwo').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeDetail[0].appointeeAgeTwo', '')
                                        document.getElementById('nomineeDetail[0].appointeeRelationshipTwo').closest('div').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeDetail[0].appointeeRelationshipTwo', '')
                                    }

                                    //console.log('gsgsg', document.getElementById('appointeeRelationship').closest('div').closest('.mb-3'))
                                }

                                if (name === 'nomineeDetail[0].nomineePercentClaim') {

                                    if (val.target.value > 100 && val.target.value != '' && val.target.value != 0) {
                                        //setFieldError('nomineeDetail[0].nomineePercentClaim', 'Percentage should not be more than 100')
                                        setFieldValue('nomineeDetail[0].nomineePercentClaim', '')
                                        document.getElementById('nomineeDetail[0].nomineeNameTwo').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeDetail[0].nomineeNameTwo', '')
                                        document.getElementById('nomineeDetail[0].nomineeAgeTwo').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeDetail[0].nomineeAgeTwo', '')
                                        document.getElementById('nomineeDetail[0].nomineeRelationshipTwo').closest('div').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeDetail[0].nomineeRelationshipTwo', '')
                                        document.getElementById('nomineeDetail[0].nomineePercentClaimTwo').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeDetail[0].nomineePercentClaimTwo', '')
                                    } else if (val.target.value < 100 && val.target.value != '' && val.target.value != 0) {
                                        let percentageTwo = 100 - val.target.value
                                        document.getElementById('nomineeDetail[0].nomineeNameTwo').closest('.mb-3').removeAttribute('hidden')
                                        document.getElementById('nomineeDetail[0].nomineeAgeTwo').closest('.mb-3').removeAttribute('hidden')
                                        document.getElementById('nomineeDetail[0].nomineeRelationshipTwo').closest('div').closest('.mb-3').removeAttribute('hidden')
                                        document.getElementById('nomineeDetail[0].nomineePercentClaimTwo').closest('.mb-3').removeAttribute('hidden')
                                        setFieldValue('nomineeDetail[0].nomineePercentClaimTwo', percentageTwo)
                                    } else {
                                        document.getElementById('nomineeDetail[0].nomineeNameTwo').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeDetail[0].nomineeNameTwo', 'null')
                                        setFieldValue('nomineeDetail[0].nomineeAgeTwo', 0)
                                        setFieldValue('nomineeDetail[0].nomineeRelationshipTwo', 'null')

                                        document.getElementById('nomineeDetail[0].nomineeAgeTwo').closest('.mb-3').setAttribute('hidden', true)
                                        //setFieldValue('nomineeDetail[0].nomineeAgeTwo', 'null')nomineeRelationshipTwo
                                        document.getElementById('nomineeDetail[0].nomineeRelationshipTwo').closest('div').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeDetail[0].nomineeRelationshipTwo', '')
                                        document.getElementById('nomineeDetail[0].nomineePercentClaimTwo').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeDetail[0].nomineePercentClaimTwo', '')

                                    }
                                }

                                /*   if (name === 'nomineeDetail[0].nomineePercentClaimTwo') {
                                      if (val.target.value > 99 && val.target.value != ''  ) {
                                          setFieldValue('nomineeDetail[0].nomineePercentClaimTwo','')
                                      }
                                  } */

                                /*  if (name === 'nomineeAgeTwo') {
                                     console.log('input console', val.target.value)
                                     if (val.target.value < 18) {
                                         document.getElementById('appointeeNameTwo').closest('.mb-3').removeAttribute('hidden')
                                         document.getElementById('appointeeAgeTwo').closest('.mb-3').removeAttribute('hidden')
                                         document.getElementById('appointeeRelationshipTwo').closest('div').closest('.mb-3').removeAttribute('hidden')
                                     } else {
                                         document.getElementById('appointeeNameTwo').closest('.mb-3').setAttribute('hidden', true)
                                         document.getElementById('appointeeAgeTwo').closest('.mb-3').setAttribute('hidden', true)
                                         document.getElementById('appointeeRelationshipTwo').closest('div').closest('.mb-3').setAttribute('hidden', true)
 
                                     }
 
                                     console.log('gsgsg', document.getElementById('appointeeRelationship').closest('div').closest('.mb-3'))
                                 }
  */
                            }
                            
                            const handleOnBlur = (val) => {
                                /* if (manualValidation !== undefined) {
                                    //console.log(manualValidation)
                                    //console.log(val.target.value)
                                    //console.log(manualValidation === 'validateNomineePercentClaim' ? manualValidation : null)
                                    let externalResponse = window[`${manualValidation}`](val.target.value)
                                    //console.log(externalResponse)
                                    setFieldError(name, externalResponse)
                                    console.log(name)

                                } else {
                                    setFieldValue(name, val.target.value)

                                }

                                if (name === 'nomineeAge') {
                                    console.log('input console', val.target.value)
                                    if (val.target.value < 18 && val.target.value !== '') {
                                        document.getElementById('appointeeName').closest('.mb-3').removeAttribute('hidden')
                                        document.getElementById('appointeeAge').closest('.mb-3').removeAttribute('hidden')
                                        document.getElementById('appointeeRelationship').closest('div').closest('.mb-3').removeAttribute('hidden')
                                    } else {
                                        document.getElementById('appointeeName').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('appointeeName', '')
                                        document.getElementById('appointeeAge').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('appointeeAge', '')
                                        document.getElementById('appointeeRelationship').closest('div').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('appointeeRelationship', '')

                                    }

                                    console.log('gsgsg', document.getElementById('appointeeRelationship').closest('div').closest('.mb-3'))
                                }
                                if (name === 'nomineeAgeTwo') {
                                    console.log('input console', val.target.value)
                                    if (val.target.value < 18 && val.target.value !== '') {
                                        document.getElementById('appointeeNameTwo').closest('.mb-3').removeAttribute('hidden')
                                        document.getElementById('appointeeAgeTwo').closest('.mb-3').removeAttribute('hidden')
                                        document.getElementById('appointeeRelationshipTwo').closest('div').closest('.mb-3').removeAttribute('hidden')
                                    } else {
                                        document.getElementById('appointeeNameTwo').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('appointeeNameTwo', '')
                                        document.getElementById('appointeeAgeTwo').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('appointeeAgeTwo', '')
                                        document.getElementById('appointeeRelationshipTwo').closest('div').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('appointeeRelationshipTwo', '')
                                    }

                                    console.log('gsgsg', document.getElementById('appointeeRelationship').closest('div').closest('.mb-3'))
                                }

                                if (name === 'nomineePercentClaim') {
                                    if (val.target.value < 100 && val.target.value !== '') {
                                        document.getElementById('nomineeNameTwo').closest('.mb-3').removeAttribute('hidden')
                                        document.getElementById('nomineeAgeTwo').closest('.mb-3').removeAttribute('hidden')
                                        document.getElementById('nomineeRelationshipTwo').closest('div').closest('.mb-3').removeAttribute('hidden')
                                        document.getElementById('nomineePercentClaimTwo').closest('.mb-3').removeAttribute('hidden')

                                    } else {
                                        document.getElementById('nomineeNameTwo').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeNameTwo', '')
                                        document.getElementById('nomineeAgeTwo').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeAgeTwo', '')
                                        document.getElementById('nomineeRelationshipTwo').closest('div').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineeRelationshipTwo', '')
                                        document.getElementById('nomineePercentClaimTwo').closest('.mb-3').setAttribute('hidden', true)
                                        setFieldValue('nomineePercentClaimTwo', '')

                                    }
                                } */
                            }


                            const validateNomineePercentageTwo = (label, val) => {
                                console.log('validate', (val), values.nomineeDetail[0].nomineePercentClaim)
                                let error;
                                if (val === '') {
                                    //setFieldValue('nomineeDetail[0].nomineePercentClaimTwo', '')
                                    //setFieldError('nomineeDetail[0].nomineePercentClaimTwo','reeor')
                                    return error

                                } else {
                                    //console.log('nomPerc2', val, values.nomineeDetail[0].nomineePercentClaim)
                                    //console.log('sum', Number(values.nomineeDetail[0].nomineePercentClaim) + Number(val))
                                    if (Number(values.nomineeDetail[0].nomineePercentClaim) + Number(val) === 100) {
                                        //setFieldValue('nomineeDetail[0].nomineePercentClaimTwo', val)

                                        return error;
                                    } else {
                                        //setFieldValue('nomineeDetail[0].nomineePercentClaimTwo', '')
                                        error = 'Nominee Percentage should be 100'
                                        return error;
                                    }

                                }
                            }

                            const validateZeroNomineePercentage = (label, val) => {
                                let error;
                                if (Number(val) === 0) {
                                    //setFieldValue('nomineeDetail[0].nomineePercentClaimTwo', '')
                                    //setFieldError('nomineeDetail[0].nomineePercentClaimTwo','reeor')
                                    error = 'Should not except 0'
                                    return error;
                                }
                            }

                            const validateNomineeNameTwo = (label, val) => {
                                let error;
                                if (Number(values.nomineeDetail[0].nomineePercentClaim) < 100 &&
                                    values.nomineeDetail[0].nomineeNameTwo === '') {
                                    error = `${label} is required`
                                    return error
                                }
                            }
                            
                            const validateNomineeAgeTwo=(label,val)=>{
                                let error;
                                if (Number(values.nomineeDetail[0].nomineePercentClaim) < 100 &&
                                    values.nomineeDetail[0].nomineeAgeTwo === '') {
                                    error = `${label} is required`
                                    return error
                                }
                            }

                            const validateField = (val) => {
                                if((productName==='My Health Suraksha New Tab' || productName==="Family Health Suraksha New Tab")) {
                                    if(name==="dependentDetail.Customer_IDProofNo" && values?.dependentDetail?.Customer_IDProof && !val){
                                        return `${label} is required`;
                                    }
                                    if(name===`primaryDetail[${arrayindex}].PropRisks_AgeProofID` && values?.primaryDetail?.[arrayindex]?.PropRisks_AgeProofDocument && !val){
                                        return `${label} is required`;
                                    }
                                    if(name===`dependentDetail.Company_Name` && values?.dependentDetail?.Customer_Type === "Corporate" && !val){
                                        return `${label} is required`;
                                    }
                                }
                                return null;
                            }

                            return (
                                <>
                                    {

                                        readOnly !== undefined ?
                                            <Field
                                                className="form-control"
                                                label={label}
                                                {...rest}
                                                id={name}
                                                hidden={hidden}
                                                disabled={Boolean(readOnly)}
                                                name={name}
                                                //value={getValueByKey(transperData,name)}
                                                {...rest}
                                                placeholder={placeholder||label}
                                                onChange={val => handleChange(val)}
                                                validate={(val) => {
                                                    return validateField(val)
                                                }}
                                            //onBlur={val => handleOnBlur(val)}

                                            /> : <FastField
                                                className="form-control"
                                                label={label}
                                                {...rest}
                                                validate={val => name === 'nomineeDetail[0].nomineeNameTwo' ?
                                                    validateNomineeNameTwo(label, val) : 
                                                    name === 'nomineeDetail[0].nomineeAgeTwo' ?
                                                    validateNomineeAgeTwo(label, val) :
                                                    name === 'nomineeDetail[0].nomineePercentClaim' ? 
                                                     validateZeroNomineePercentage(label, val):
                                                     validateField(val)
                                                }
                                                /*  validate={val => name === 'nomineeDetail[0].nomineePercentClaimTwo'  ?
                                                     validateNomineePercentageTwo(label, val) : 
                                                     name === 'nomineeDetail[0].nomineePercentClaim' ? 
                                                     validateZeroNomineePercentage(label, val):null} */
                                                id={name}
                                                hidden={hidden}
                                                //readOnly={readOnly !== undefined ? readOnly : null}
                                                name={name}
                                                {...rest}
                                                placeholder={placeholder||label}
                                                onChange={val => handleChange(val)}
                                                onBlur={val => handleOnBlur(val)}
                                                onWheel={(e) =>
                                                    type === "number" ? e.currentTarget.blur() : null
                                                  }

                                            />
                                    }
                                </>
                            )

                        }
                    }

                </Field>

                <ErrorMessage name={name} component={TextError} />

            </div>



        </div >
    )
}

export default FormikInput